/*
 * Decimal, Account Management App.
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 * Account is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */

import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { httpInterceptorProviders } from '../http/interceptor';
import { ApiService } from '../http/api.service';
import { UtilityService } from './utility.service';
import { ConsoleHomeService } from './console-home.service';
import { ConsoleGuard } from '../guards/console.guard';

/**
 * ServicesModule
 */
@NgModule({
  declarations: [],
  imports: [CommonModule]
})
export class ServicesModule {
  /**
   * forRoot
   * httpInterceptorProviders,
   * ApiService,
   * ResetService,
   * HeaderService,
   * SignoutService,
   * UtilityService,
   * SigninService,
   * SignupService,
   * WorkspaceService,
   * ConfirmationEmailService
   */
  static forRoot(): ModuleWithProviders<ServicesModule> {
    return {
      ngModule: ServicesModule,
      providers: [
        httpInterceptorProviders,
        ApiService,
        UtilityService,
        ConsoleHomeService,
        ConsoleGuard
      ]
    };
  }
}
